// @flow
import { createSelector } from 'reselect';

import type {
  AdPartnerReducer,
  AdPartner,
  AdPartnerMachineNameToCompanyNameMapping
} from '../../types/adPartnerTypes';

export function isAdPartnerVisible(partner: AdPartner) {
  return (
    partner.status === 'active' ||
    // case: custom ad partner. Always show
    partner.machine_name.includes('a_custom_') ||
    // case: tune ad network blueprint. Show if a configuration exists (entry in ad_network).
    (partner.status === 'tune' && !partner.neverConfigured)
  );
}

export const getAdPartnerState: (state: any) => AdPartnerReducer = state =>
  state && state.ad_partner;

export const getLoadingState: (state: any) => boolean = createSelector(
  getAdPartnerState,
  state => state.loading
);

export const getPartners: (state: any) => AdPartner[] = createSelector(
  getAdPartnerState,
  state => (state && state.partners) || []
);

export const selectVisibleAdPartners: (
  state: any
) => AdPartner[] = createSelector(
  getPartners,
  partners => partners.filter(isAdPartnerVisible)
);

export const getAdPartnerMachineNameToCompanyNameMapping: (
  state: any
) => AdPartnerMachineNameToCompanyNameMapping = createSelector(
  selectVisibleAdPartners,
  visiblePartners => {
    const mapping: AdPartnerMachineNameToCompanyNameMapping = {};
    visiblePartners.forEach(({ machine_name, company_name }) => {
      mapping[machine_name] = company_name;
    });
    return mapping;
  }
);

export const getSelectedPartner: (state: any) => ?AdPartner = createSelector(
  getAdPartnerState,
  adPartnerState => adPartnerState.selectedPartner
);

export const getAdPartner: (
  state: any,
  props: any
) => ?AdPartner = createSelector(
  getPartners,
  (state, props) => props.machineName,
  (partners, machineName) =>
    partners.find(partner => partner.machine_name === machineName)
);
